import './MenuButtonIcon.css'

export default function MenuButtonIcon({
  open,
  handleOpen
}: {
  open: boolean
  handleOpen: (o: boolean) => void
}) {
  return (
    <button
      className={`menu-button-icon only-mobile ${open ? 'is-active' : ''}`}
      onClick={() => handleOpen(!open)}
    >
      <span className="bars" />
    </button>
  )
}
